// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3zP5d","choiceBoxes":"toolbarselects_choiceBoxes__3b6R6","simpleField":"toolbarselects_simpleField__1m_pH"};